<script setup lang="ts">
const { t } = useI18n();

definePageMeta({
  page_name: "home",
});
</script>

<template>
  <main>
    <section class="hero">
      <div class="hero-content">
        <h1 class="hero-title">{{ t("home.hero.title") }}</h1>
        <p class="hero-subtitle">{{ t("home.hero.subtitle") }}</p>
        <a href="#services" class="btn btn-primary">
          {{ t("home.hero.cta") }}
        </a>
      </div>
    </section>

    <section id="services" class="services">
      <div class="container">
        <h2 class="section-title">{{ t("home.services.title") }}</h2>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">🏷️</div>
            <h3>{{ t("home.services.logo_title") }}</h3>
            <p>{{ t("home.services.logo_desc") }}</p>
          </div>
          <div class="service-card">
            <div class="service-icon">📋</div>
            <h3>{{ t("home.services.labels_title") }}</h3>
            <p>{{ t("home.services.labels_desc") }}</p>
          </div>
          <div class="service-card">
            <div class="service-icon">🧵</div>
            <h3>{{ t("home.services.embroidery_title") }}</h3>
            <p>{{ t("home.services.embroidery_desc") }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="features">
      <div class="container">
        <h2 class="section-title">{{ t("home.features.title") }}</h2>
        <div class="features-grid">
          <div class="feature-item">
            <h3>⭐ {{ t("home.features.quality_title") }}</h3>
            <p>{{ t("home.features.quality_desc") }}</p>
          </div>
          <div class="feature-item">
            <h3>💰 {{ t("home.features.price_title") }}</h3>
            <p>{{ t("home.features.price_desc") }}</p>
          </div>
          <div class="feature-item">
            <h3>🚚 {{ t("home.features.shipping_title") }}</h3>
            <p>{{ t("home.features.shipping_desc") }}</p>
          </div>
          <div class="feature-item">
            <h3>🎨 {{ t("home.features.custom_title") }}</h3>
            <p>{{ t("home.features.custom_desc") }}</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
